import React, { useState } from "react";
import "./SignInModal.css";
import { Link } from "react-router-dom";
import logo from "../Assets/logo.png";


const SignInModal = ({ show, onClose }) => {
  const [email, setEmail] = useState("");
  const [offers, setOffers] = useState(false);


  


  const handleContinue = () => {
       // Handle email login or redirect to next step
     //console.log("Continue with email:", email);
    // navigate("/account"); // Example: next step
    };


    const handleSocialLogin = (provider) => {
    // console.log(`Continue with ${provider}`);
    // Implement OAuth login logic here
  };




  if (!show) return null;



  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close modal">&times;</button>
        
        <div className="modal-header-logo">
        <img src={logo} alt="RedboxGlobal Logo" className="modal-logo" />
        <span className="modal-logo-text">Redbox Global</span>
        
        </div>
        <h2 className="modal-title">Sign in</h2>
        <p className="modal-subtext">Please enter your email to sign in.</p>
        <div className="modal-checkbox-row">
          <input
            type="checkbox"
            id="offers"
            checked={offers}
            onChange={() => setOffers(!offers)}
          />
          <label htmlFor="offers">RedboxGlobal may send me offers and promotions.</label>
        </div>
        <div className="modal-terms">
          By submitting my information, I agree to the {" "}
           <a href="/privacy" target="_blank" rel="noopener noreferrer" onClick={onClose}>Privacy Policy</a>{" "}  and{" "} <a href="/terms" target="_blank" rel="noopener noreferrer" onClick={onClose}>Terms of Service </a>.
        </div>
        <input
          type="email"
          className="modal-email-input"
          placeholder="Enter your email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <button className="modal-continue-btn" disabled={!email}>Continue</button>
        <div className="modal-or-divider">
          <span>or</span>
        </div>
        <div className="modal-social-buttons">
          <button className="modal-social-btn google">
            <svg width="18" height="18" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.7 1.2 9.2 3.6l6.9-6.9C35.7 2.2 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l8.1 6.3C12.5 13.1 17.8 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.1 24.5c0-1.7-.2-3.3-.5-4.8H24v9.1h12.4c-.5 2.7-2 5-4.2 6.6l6.5 5c3.8-3.5 6.4-8.7 6.4-15.9z"/>
      <path fill="#FBBC05" d="M10.7 28.1c-1-2.7-1-5.6 0-8.3l-8.1-6.3C.9 16.7 0 20.3 0 24s.9 7.3 2.6 10.5l8.1-6.4z"/>
      <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.6l-6.5-5c-2 1.3-4.6 2.1-9.1 2.1-6.2 0-11.5-3.6-13.3-8.8l-8.1 6.4C6.5 42.6 14.6 48 24 48z"/>
     </svg>
          <span> Continue with Google</span> 
          </button>
          <button className="modal-social-btn apple">
             <svg width="18" height="18" viewBox="0 0 24 24" fill="black">
            <path d="M16.365 1.43c0 1.14-.43 2.19-1.15 2.94-.76.8-2.03 1.42-3.24 1.32-.15-1.12.44-2.29 1.15-3.05.78-.83 2.13-1.47 3.24-1.21zm2.85 16.38c-.8 1.17-1.63 2.33-2.94 2.36-1.3.03-1.72-.77-3.21-.77-1.5 0-1.97.74-3.18.8-1.23.05-2.17-1.26-2.97-2.43-1.63-2.38-2.88-6.72-1.2-9.64.83-1.45 2.32-2.37 3.95-2.4 1.23-.02 2.39.83 3.14.83.75 0 2.15-1.02 3.63-.87.62.02 2.37.25 3.5 1.9-.09.06-2.08 1.21-2.06 3.61.02 2.86 2.51 3.81 2.54 3.82-.02.07-.4 1.38-1.2 2.79z"/>
            </svg>

           <span> Continue with Apple</span>
          </button>
          <button className="modal-social-btn email">
            <span>✉️ Continue with Email</span>
          </button>
        </div>
        <div className="modal-footer-links">
          {/* <span>Don't have an account? <Link to="/signup" onClick={onClose}>Create one</Link></span> */}
          <span>
        Don't have an account?{" "}
          <a href="/signup" target="_blank" rel="noopener noreferrer" onClick={onClose}>Create one
        </a>
         </span>
          <br />
          <a href="/help" target="_blank" rel="noopener noreferrer" onClick={onClose}>Need help?</a>
        </div>
      </div>
    </div>
  );
};

export default SignInModal;
